import { fetchHelper } from "../utils"

export const getVideoMaterials = async () => {
    return fetchHelper({
        url: 'videoMaterials',
        method: 'GET',
    }) as Promise<any[]>
}

export const postVideoMaterial = async (body: any) => {
    return fetchHelper({
        url: 'videoMaterials',
        method: 'POST',
        body
    }) as Promise<any>
}

export const postMediaConvertJob = async (body: any) => {
    return fetchHelper({
        url: 'videomaterials/mediaconvert/jobs',
        method: 'POST',
        body
    }) as Promise<any>
}